// DS2.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './GhostButton.scss';
const GhostButton = (_param)=>{
    var { size, variant, fillContainerWidth, className, children, icon: IconComponent, postfixIcon: PostFixIconComponent, loading, rounded } = _param, props = _object_without_properties(_param, [
        "size",
        "variant",
        "fillContainerWidth",
        "className",
        "children",
        "icon",
        "postfixIcon",
        "loading",
        "rounded"
    ]);
    const iconSize = useIconSizeForButtonSize(size);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(className, s['root'], s[`variant-${variant}`], s[`size-${size}`], fillContainerWidth && s['fill-container-width'], rounded && s['rounded'], props.disabled && s['disabled'], loading && s['loading'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children), PostFixIconComponent && /*#__PURE__*/ React.createElement(PostFixIconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }));
};
GhostButton.displayName = 'GhostButton';
export default GhostButton;

//# sourceMappingURL=GhostButton.js.map